/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { Spin, Checkbox, message, Button, Input } from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
const { GET_AGGREMENT_LIST } = urls;
import { customerOnboardingAPI } from "../../../api/LeadApi";
import "../style.scss";
import AgreementSuccessModal from "../../../components/QuotationPrint/aggrementSuccess";
import { validateClientOrgDetails } from "./validateFields";
const AggreementDetails = ({
  goBackStep,
  getData,
  handleStepsChange = () => {},
  userType,
  goToStep,
}) => {
  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [aggrementList, setAggrementList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mannualAggrement, setMannualAggrement] = useState(null);
  const [showTextArea, setShowTextArea] = useState(false);
  const [isAggreementListReady, setIsAggreementListReady] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const fetchAgreementList = async () => {
      setLoading(true);
      try {
        const res = await API.Api(GET_AGGREMENT_LIST).getWithAllHeaders();
        if (res?.status) {
          const data = res?.response?.data || [];
          const formattedData = data.map((e) => ({
            label: e.agreementDetails,
            value: e.agreementDetails,
            id: e.leadAgreementId,
            disabled: e.mandatory,
            checked: e.mandatory,
          }));

          setAggrementList(formattedData);
          setCheckedList(
            formattedData.filter((e) => e.checked).map((e) => e.value)
          );
        } else {
          message.error(
            res?.response?.data?.message || "Can't fetch agreement."
          );
        }
      } catch (error) {
        message.error("Something went wrong while fetching agreements.");
      } finally {
        setLoading(false);
        setIsAggreementListReady(true);
      }
    };

    fetchAgreementList();
  }, []);

  useEffect(() => {
    if (isAggreementListReady && getData?.agreements?.length > 0) {
      const formattedArr2 = getData.agreements.map((item) => ({
        label: item.agreementDetails,
        value: item.agreementDetails,
        id: item.leadAgreementId,
        disabled: false,
        checked: true,
      }));

      const mergedMap = new Map();

      aggrementList.forEach((item) => {
        mergedMap.set(item.value, item);
      });

      formattedArr2.forEach((item) => {
        if (mergedMap.has(item.value)) {
          mergedMap.set(item.value, {
            ...mergedMap.get(item.value),
            checked: item.checked,
          });
        } else {
          mergedMap.set(item.value, item);
        }
      });

      const mergedArray = Array.from(mergedMap.values());
      setAggrementList([...mergedArray]);
      setCheckedList(mergedArray.filter((e) => e.checked).map((e) => e.value));
    }
  }, [isAggreementListReady, getData]);

  const addNewAggrement = () => {
    setAggrementList((prev) => [
      ...prev,

      {
        label: mannualAggrement,
        value: mannualAggrement,
      },
    ]);
    setMannualAggrement("");
    setShowTextArea(false);
  };

  const onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < aggrementList.length);
    setCheckAll(list.length === aggrementList.length);
  };
  const onCheckAllChange = (e) => {
    setCheckedList(
      e.target.checked
        ? aggrementList?.map((e) => e.label)
        : aggrementList?.map((e) => (e.disabled ? e?.label : ""))
    );

    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  // eslint-disable-next-line no-unused-vars
  const saveAggrement = async (btnType) => {
    setLoading(true);
    let user =
      {
        CLIENT: "clientLeadId",
        COMPANY: "customerIdCompany",
      }[userType] || "customerId";
    const id = localStorage.getItem(user) || getData?.customerId;
    let payload = {
      agreements: checkedList?.map((item) => ({ agreementDetails: item })),
    };
    // if (userType === "CLIENT") {
    //   if (validateClientOrgDetails(getData)) {
    //     message.error("Fill all the required fields");
    //     goToStep(0);
    //     return;
    //   }
    // }
    let response = await customerOnboardingAPI.patchLead(id, payload);

    if (response?.status) {
      setLoading(false);
      if (userType === "CLIENT") {
        setShowSuccessModal(true);
      } else {
        message.success("Aggrement added successfully.");
        btnType === "continue" && handleStepsChange(1);
      }
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };

  return (
    <Spin
      spinning={loading}
      size="large"
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="cp-lead-gen-container p-2">
        {}
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={checkAll}
          disabled={getData?.status?.toLowerCase() === "approved"}
        >
          Select All
        </Checkbox>
        <CheckboxGroup
          options={aggrementList}
          value={checkedList}
          onChange={onChange}
          className="aggrement-check"
          disabled={getData?.status?.toLowerCase() === "approved"}
        />

        {showTextArea ? (
          <>
            <div className="mt-2">
              <span>Enter Aggrement</span>
              <TextArea
                onChange={(e) => setMannualAggrement(e.target.value)}
                placeholder="Enter Aggrement"
                style={{ borderRadius: "5px" }}
              />
            </div>
            <div className="flex-end">
              <Button
                className="save-btn mt-1"
                onClick={addNewAggrement}
                disabled={!mannualAggrement}
              >
                Save
              </Button>
            </div>
          </>
        ) : null}

        <div className="flex-end" onClick={() => setShowTextArea(true)}>
          <Button
            className="save-btn mt-1"
            disabled={getData?.status?.toLowerCase() === "approved"}
          >
            Add More
          </Button>
        </div>
      </div>
      <div className="flex-end m-1">
        <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
          BACK
        </Button>
        {getData?.status?.toLowerCase() !== "approved" ? (
          <>
            <Button
              htmlType="submit"
              className="cancel-btn ml-1 w-15"
              onClick={() => saveAggrement("save")}
            >
              SAVE
            </Button>

            <Button
              htmlType="submit"
              className="save-btn  ml-1"
              id="saveNContinue"
              onClick={() => saveAggrement("continue")}
            >
              SAVE & CONTINUE
            </Button>
          </>
        ) : (
          <Button
            id="saveNContinue"
            onClick={() => handleStepsChange(1)}
            className="save-btn  ml-1"
          >
            NEXT
          </Button>
        )}
      </div>
      {showSuccessModal && userType === "CLIENT" && (
        <AgreementSuccessModal
          visible={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
          onNext={() => handleStepsChange(1)}
          onPrint={() => {
            handleStepsChange(1);
          }}
          onSendMail={() => {
            handleStepsChange(1);
          }}
        />
      )}
    </Spin>
  );
};
export default AggreementDetails;
